import { DisabledPrompt } from "bcms-react";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView, WidgetContainer, WidgetView } from "components/shared";
import React from "react";
import { SVGAsset } from "res";
import "./mobile.css";
import "./styles.css";

/**
 * @function AuthorizedAppsWidget
 * @return {React.Component}
 * @exported true
 * @description Shows the authorized apps
 */

export default function AuthorizedAppsWidget(props) {
  return(
    <WidgetContainer className="authorized-apps-widget">
      <WidgetView text="AUTHORIZED APPS">
        <TableView>
          <TableColumnContainer>
            <TableColumnView 
              className="text-left" 
              text={<>
                <span>Nickname</span>
                <DisabledPrompt>
                  <SVGAsset id='ArrowUpIcon' className='clickable' />
                </DisabledPrompt>
                </>} />
            <TableColumnView 
              className="text-left" 
              text={<>
                <span>Authorized</span>
                <DisabledPrompt>
                  <SVGAsset id='SortIcon' className='clickable' />
                </DisabledPrompt>
                </>} />
            <TableColumnView 
              className="text-left" 
              text={<>
                <span>Last Accessed</span>
                <DisabledPrompt>
                  <SVGAsset id='SortIcon' className='clickable' />
                </DisabledPrompt>
                </>} />
          </TableColumnContainer>
          <TableBody>
            <TableItemContainer>
              <td colSpan="3" className="text-center table-item-text-view no-apps-text">No apps have been authorized</td>
            </TableItemContainer>
          </TableBody>
        </TableView>
      </WidgetView>
    </WidgetContainer>
  );
}